import './commontasks.css'
import React from 'react'
import { useState } from 'react';
import { Delete } from "@mui/icons-material"
import EditIcon from '@mui/icons-material/Edit';
import { ArrowForwardIcon } from '../customicons/ArrowForwardIcon';

import CommonTasksContext from '../../../contexts/CommonTasksContext'
import StatusContext from '../../../contexts/StatusContext'


export const DisplayCustomPrompts = ({ prompt, seqid, total }) => {

  const [iconPosition] = useState({ x: 0, y: 0 });


  let {
    setCustomPromptsStatus,
    onSubmitPrompt,
    setShowCustomPromptDialog,
    setCustomPrompt,

    setAddPromptMode,
    getPromptIndexByName,
    onShowDeleteCustomPromptDialog,
  } = React.useContext(CommonTasksContext);

  let {
    isLoading,
    changeLanguage,
  } = React.useContext(StatusContext);


    const onEdit = () => {
    if (prompt.default) {
      setCustomPromptsStatus(changeLanguage("common", "dialogdefaultpromptedit"))
      return
    }
    else {
      setCustomPromptsStatus('')
      setAddPromptMode(false)
      setShowCustomPromptDialog(true);
      setCustomPrompt(prompt)
    }
  }

  const onSubmit = (prompt) => {
    setCustomPromptsStatus('')
    setShowCustomPromptDialog(false)
    onSubmitPrompt(prompt)
  }

  const onDelete = () => {
    setCustomPromptsStatus("")
   
    if (prompt.default)
    {
      setCustomPromptsStatus(changeLanguage('common', 'deletedefaultprompt'))
      return
    }

    let id = getPromptIndexByName(prompt)

    if (id >= 0) {
      prompt.id = id
      setCustomPrompt(prompt)
      onShowDeleteCustomPromptDialog(prompt)
    }
  
  }

  return (
    <>
      <div className="displayCustomPrompts">
        <span style={{ paddingLeft: '5px', paddingRight: '2px', paddingTop: '4px', fontSize: '12px', color: 'maroon' }}>{`${seqid}/${total}`}</span>

        <EditIcon className="promptIcon"  onClick={() => {  !isLoading && onEdit() }} />
        <Delete className="promptIcon" onClick={() => { !isLoading && onDelete() }} />

        <li
          className="customPromptChoose"
        >
        <div className="custompromptName">
          {prompt.name}
          </div>
          <div className="custompromptText">
            {prompt.prompt}
          </div>

        </li>

        <div
          style={{ marginRight:'15px', position: 'relative', left: iconPosition.x, top: iconPosition.y }}>

          <ArrowForwardIcon className="iconWithBackground" onClick={() => { onSubmit(prompt.prompt) }} />
        </div>

      </div>
      <hr className='customLineSeparator'></hr>
    </>

  )
}

DisplayCustomPrompts.defaultProps = {
  editmode: false
};